import { useEffect, useState } from "react";

interface ShareModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

const platforms = [
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-qq-fill", label: "QQ" },
  { icon: "ri-link", label: "复制链接" },
];

export default function ShareModal({ open, onClose, title }: ShareModalProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (open) setCopied(false);
  }, [open]);

  useEffect(() => {
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    if (open) document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [open, onClose]);

  if (!open) return null;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-foreground-950/50 animate-fade-in"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-lg bg-background-50 border border-background-200 p-6 animate-slide-down"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="font-heading font-semibold text-lg text-foreground-950">
              分享给朋友
            </h3>
            <p className="mt-1 text-sm text-foreground-500 line-clamp-1">{title}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-500 hover:bg-background-100 cursor-pointer"
            aria-label="关闭"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        <div className="mt-6 grid grid-cols-4 gap-3">
          {platforms.map((item) => (
            <button
              key={item.label}
              type="button"
              onClick={item.label === "复制链接" ? copyLink : undefined}
              className="flex flex-col items-center gap-2 py-3 rounded-md bg-background-100 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 dark:text-foreground-950">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <span className="text-xs text-foreground-700">{item.label}</span>
            </button>
          ))}
        </div>

        <p className="mt-5 text-xs text-center text-foreground-500">
          {copied ? "链接已复制到剪贴板（演示）" : "分享功能为演示效果，不会真实发布到社交平台"}
        </p>
      </div>
    </div>
  );
}